/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestCreateTrackingLogModel } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TrackingLogServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestCreateTrackingLogModel 
     */
    trackingLogControllerCreate0(apiRequestCreateTrackingLogModel: ApiRequestCreateTrackingLogModel, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param apiRequestCreateTrackingLogModel 
     */
    trackingLogControllerCreate1(apiRequestCreateTrackingLogModel: ApiRequestCreateTrackingLogModel, extraHttpRequestParams?: any): Observable<{}>;

}
